/**
 * /app/$tenantSlug/attendance — legacy redirect → /my-time (docs/47 P1).
 *
 * The punch-card surface moved into the unified My Time page (Zone A). This
 * index route now redirects so old links / bookmarks land on the merged
 * page. The deep sub-routes (attendance/team, attendance/regularize,
 * attendance/import, attendance/approvals) are PRESERVED — only this index
 * collapses into My Time.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/attendance/",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/$tenantSlug/my-time",
      params: { tenantSlug: params.tenantSlug },
    });
  },
});
